module.exports = __webpack_public_path__ + "img/lefthlstou.5f3691e3.png";